import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartProducts: [],
    cartQuantity: 0,
    cartTotal: 0,
  },
  reducers: {
    addProduct: (state, action) => {
      const existingIndex = state.cartProducts.findIndex(
        (item) => item._id === action.payload._id
      );
      // console.log(action.payload._id);
      // console.log(existingIndex);

      if (existingIndex >= 0) {
        // console.log(state.cartProducts[existingIndex].price);
        // console.log(
        //   state.cartProducts[existingIndex].price *
        //     state.cartProducts[existingIndex].cartQuantity
        // );
        state.cartProducts[existingIndex] = {
          ...state.cartProducts[existingIndex],
          cartQuantity: state.cartProducts[existingIndex].cartQuantity + 1,
        };
        state.cartTotal =
          state.cartProducts[existingIndex].price *
          state.cartProducts[existingIndex].cartQuantity;
      } else {
        let tempProductItem = { ...action.payload, cartQuantity: 1 };
        // console.log(action.payload.price);
        state.cartTotal += action.payload.price * action.payload.quantity;
        state.cartQuantity += 1;
        state.cartProducts.push(tempProductItem);
      }
    },
    decreaseProduct: (state, action) => {
      const itemIndex = state.cartProducts.findIndex(
        (item) => item._id === action.payload._id
      );

      if (state.cartProducts[itemIndex].cartQuantity > 1) {
        state.cartProducts[itemIndex].cartQuantity -= 1;
        state.cartTotal =
          state.cartProducts[itemIndex].price *
          state.cartProducts[itemIndex].cartQuantity;
      } else if (state.cartProducts[itemIndex].cartQuantity === 1) {
        const nextCartProducts = state.cartProducts.filter(
          (item) => item._id !== action.payload._id
        );

        state.cartQuantity = 0;
        state.cartTotal = 0;
        state.cartProducts = nextCartProducts;
      }
    },
  },
});

export const { addProduct, decreaseProduct } = cartSlice.actions;
export default cartSlice.reducer;
